import { LOCALES, createI18n, negotiateLocale } from "@uzverse/shared";
import type { I18nInstance, Locale } from "@uzverse/shared";
import { brandMessages } from "./brandMessages.js";
import { webMessages } from "./messages.js";

const STORAGE_KEY = "uz.locale";

function readStoredLocale(): Locale | null {
  try {
    const stored = globalThis.localStorage.getItem(STORAGE_KEY);
    return LOCALES.find((l) => l === stored) ?? null;
  } catch {
    return null;
  }
}

export function storeLocale(locale: Locale): void {
  try {
    globalThis.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // Storage can be unavailable (private mode); the choice then lasts for this visit only.
  }
}

/** Creates the app's i18n instance: stored choice, else the browser language, else Turkish. */
export function createAppI18n(initial?: Locale): I18nInstance {
  const locale =
    initial ??
    readStoredLocale() ??
    negotiateLocale(typeof navigator === "undefined" ? undefined : [...navigator.languages]);
  return createI18n({ locale, bundles: [webMessages, brandMessages] });
}

export { brandMessages, webMessages };
